@for (item of items; track item; let i = $index) {
<app-custom-fields
    [customField]="item"
    [isHiddenRemoveButton]="items.length <= 1"
    (newCustomField)="newEntry($event)"
    (deleteCustomField)="deleteEntry($event)"
    (changeCustomField)="discloseValidatorChange()"
    [possibleFields]="possibleFields"
    [keyPatternValidation]="keyPatternValidation">
</app-custom-fields>
}
